"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _listField = _interopRequireDefault(require("./list-field"));

var _chainedSelectField = _interopRequireDefault(require("./chained-select-field"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ChainedSelectListField = /*#__PURE__*/function (_ListField) {
  (0, _inherits2.default)(ChainedSelectListField, _ListField);

  var _super = _createSuper(ChainedSelectListField);

  function ChainedSelectListField() {
    var _this;

    (0, _classCallCheck2.default)(this, ChainedSelectListField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'ChainedSelectListField');
    return _this;
  }

  (0, _createClass2.default)(ChainedSelectListField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(ChainedSelectListField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'fieldFactory',
            required: false
          }, {
            name: 'options',
            component: 'ChainedSelectOptionsField',
            docLevel: 'basic'
          }, {
            name: 'blankString',
            component: 'TextField'
          }]
        }
      });

      this._setDefaults(props, {
        allowDelete: true,
        autoCreateFields: true,
        canDeleteEmpty: false,
        startWithField: true
      });
    }
  }, {
    key: "_newField",
    value: function _newField(name) {
      return new _chainedSelectField.default(_objectSpread({
        name: name,
        hideLabel: true,
        block: true
      }, this.get(['blankString', 'fullWidth', 'options', 'useDisplayValue', 'editable'])));
    }
  }, {
    key: "_setFieldOptions",
    value: function _setFieldOptions(name) {
      var field = this._getOrCreateField(name);

      field.set({
        options: this.get('options')
      });
    }
  }, {
    key: "_onFieldCreated",
    value: function _onFieldCreated(field
    /* onDelete */
    ) {
      var _this2 = this;

      field.on('value', function (value) {
        // Create last field if the last field is not blank and we are allowed to add more fields
        if (!_this2._isLastFieldBlank() && _this2.canAddMoreFields(value)) {
          _this2.createField();
        }

        _this2._calcValue();
      });
    }
  }, {
    key: "_setOptions",
    value: function _setOptions(options) {
      // Set the options for the first field
      this._setFieldOptions(0); // Set options for all fields


      this.eachField(function (field) {
        return field.set({
          options: options
        });
      });
    }
  }, {
    key: "set",
    value: function set(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(ChainedSelectListField.prototype), "set", this).call(this, props);

      if (props.options !== undefined) {
        this._setOptions(props.options);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      var clonedField = (0, _get2.default)((0, _getPrototypeOf2.default)(ChainedSelectListField.prototype), "clone", this).call(this); // Clear the fields as the listeners now have the wrong references to the fields, etc...

      clonedField._fields.clear(); // Create the first field


      clonedField._setOptions(this.get('options')); // Copy any existing value


      clonedField.setValue(this.getValue());
      return clonedField;
    }
  }]);
  return ChainedSelectListField;
}(_listField.default);

exports.default = ChainedSelectListField;